import { type ElementType, type HTMLAttributes, type ReactNode, type Ref, forwardRef } from 'react'
import tw, { TwStyle } from 'twin.macro'

type ContainerProps<T extends ElementType> = {
  as?: T
  children: ReactNode
  twStyle?: TwStyle
} & HTMLAttributes<HTMLDivElement>

export default forwardRef(function Container<T extends ElementType>(
  { children, twStyle, ...rest }: ContainerProps<T>,
  ref: Ref<HTMLDivElement>
) {
  return (
    <div ref={ref} css={[tw`max-w-[1176px] px-5 mx-auto`, twStyle]} {...rest}>
      {children}
    </div>
  )
})
